function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { AppContext } from 'context';
import history from 'helpers/history';
import Button from 'components/Form/Button';
import App from 'modules/App';
import messages from '../../../messages';
const RequestSent = ()=>{
    const { getUrl } = useContext(AppContext);
    const onBack = ()=>{
        const backUrl = getUrl('organization-memberships');
        history.push(backUrl);
    };
    return /*#__PURE__*/ _jsxs("section", {
        className: "section",
        children: [
            /*#__PURE__*/ _jsx("header", {
                className: "section__header",
                children: /*#__PURE__*/ _jsx("h2", {
                    className: "text--h2 text--bold",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.createOrganizationSent))
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col",
                        children: /*#__PURE__*/ _jsx("p", {
                            className: "text--paragraph mb-7",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.createOrganizationSent))
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/aid/assets/svg/success.svg",
                            className: "ml-4",
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: App.messages.buttons.close,
                className: "btn--block btn--filled",
                onClick: onBack
            })
        ]
    });
};
export default RequestSent;
